import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Users } from "lucide-react";
import { addDeptMember, listDeptMembers, removeDeptMember } from "../../api/departments";
import { DepartmentMemberAdd } from "./DepartmentMemberAdd";
import { DepartmentMemberRow } from "./DepartmentMemberRow";

// بطاقة "موظفو القسم" فقط — المدير يظهر بجانب حقله في الأعلى.
export const DepartmentMembers = ({ deptId, branchName }) => {
  const { t } = useTranslation();
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!deptId) return;
    setLoading(true);
    try { setMembers(await listDeptMembers(deptId)); }
    finally { setLoading(false); }
  }, [deptId]);
  useEffect(() => { load(); }, [load]);

  const add = async (u) => {
    try { await addDeptMember(deptId, u.id); toast.success(t("departments.members.added")); await load(); }
    catch { toast.error(t("errors.generic")); }
  };
  const remove = async (u) => {
    if (!window.confirm(t("departments.members.confirmRemove", { name: u.name || u.email }))) return;
    try { await removeDeptMember(deptId, u.id); toast.success(t("departments.members.removed")); await load(); }
    catch { toast.error(t("errors.generic")); }
  };

  return (
    <div className="neu p-4" data-testid="dept-members-panel">
      <div className="mb-3 flex flex-wrap items-center gap-2">
        <Users className="h-4 w-4 text-primary" />
        <p className="text-sm font-bold">{t("departments.members.title")}</p>
        <span className="text-[11px] text-muted-foreground">({members.length})</span>
        {branchName ? (
          <span className="ms-auto text-[11px] text-muted-foreground">
            {t("departments.members.scope", { branch: branchName })}
          </span>
        ) : null}
      </div>

      {!deptId ? (
        <p className="rounded-2xl bg-muted/40 px-3 py-3 text-xs text-muted-foreground" data-testid="dept-members-empty">
          {t("departments.members.saveFirst")}
        </p>
      ) : (
        <DepartmentMemberAdd deptId={deptId} existingIds={members.map((m) => m.id)} onAdd={add} />
      )}

      <ul className="mt-4 space-y-2" data-testid="dept-members-list">
        {!deptId ? null : loading ? null : members.length === 0 ? (
          <li className="py-6 text-center text-xs text-muted-foreground">
            {t("departments.members.emptyList")}
          </li>
        ) : (
          members.map((u) => (
            <DepartmentMemberRow key={u.id} user={u} onRemove={remove} />
          ))
        )}
      </ul>
    </div>
  );
};
